import {FeatureFlagActionConstants as actionNames} from './state/action-names';

function ReduxFeatureFlags(
    FeatureFlags,
    $ngRedux
) {
    const actions = this;

    // feature flag keys defined in LaunchDarkly
    actions.keys = FeatureFlags.keys;

    actions.retrieveFlag = function retrieveFlag(featureFlagKey) {
        return FeatureFlags.retrieveFlag(featureFlagKey).then(result => {
            $ngRedux.dispatch({
                type: actionNames.SET_FEATURE_FLAG,
                flagKey: featureFlagKey,
                flagValue: result
            });
            return result;
        });
    };
}
ReduxFeatureFlags.$inject = [
    'FeatureFlags',
    '$ngRedux'
];

export const ReduxFeatureFlagsActions = ReduxFeatureFlags;
